import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import { VALIDATION_EXCLUDED_REASONS } from 'common/constants';

const SelectExclusionReason = props => {
  const { className, onChange, ...rest } = props;

  return (
    <TextField
      className={className}
      fullWidth
      InputLabelProps={{ shrink: true }}
      label="Exclusion reason"
      margin="dense"
      defaultValue=""
      onChange={e => onChange(e.target.value)}
      select
      SelectProps={{ native: true }}
      variant="outlined"
      {...rest}>
      <option disabled value="">
        Select a reason
      </option>
      {Object.keys(VALIDATION_EXCLUDED_REASONS).map(key => (
        <option key={key} value={key}>
          {VALIDATION_EXCLUDED_REASONS[key]}
        </option>
      ))}
    </TextField>
  );
};

SelectExclusionReason.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default SelectExclusionReason;
